import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { LoadingSpinnerService } from './../../../shared/services/loading-spinner.service';
import { SecurityService } from './../../security.service';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class ForgotPasswordGuard implements CanActivate {

  constructor(private router: Router, private loader: LoadingSpinnerService,
    private securityService: SecurityService, private toastr:ToastsManager) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    return this.securityService.forgotPasswordCheckActivationCode(route.params['token']).do((data)=>{
        if(!data)
            this.toastr.error('Wrong url provided for password reset','Error')
    });
     
  }

}


// WEBPACK FOOTER //
// ./src/app/security/security/forgot-password/forgot-password.guard.ts